import { domain } from 'helpers/constants';
import { Domain } from 'models/domain';
import { TLD, targetMarketPerTld } from '../models/TargetMarket';
import { languageCodePerTld } from '../models/languageCodePerTld';

export function buildDomainsForSubdomain(subdomain: string): Domain[] {
  return (Object.keys(targetMarketPerTld) as TLD[]).map((tld) => {
    const languageCode = languageCodePerTld[tld];
    const countryCode =
      tld === 'co.uk' ? 'GB' : tld === 'eu' ? 'EU' : tld.toUpperCase();
    const hreflang = tld === 'eu' ? 'en' : `${languageCode}-${countryCode}`;

    return {
      domain: `${subdomain}.${domain}.${tld}`,
      hreflang
    };
  });
}
